import React from 'react'
import { Modal } from '@/components/ui/Modal'
import { Trash } from 'phosphor-react'

interface ViewsModalProps {
  views: { title: string; selected: boolean }[]
  onClose: () => void
  onSelectView: (view: string) => void
  onDeleteView?: (view: string) => void
}

export const ViewsModal: React.FC<ViewsModalProps> = ({
  views,
  onClose,
  onSelectView,
  onDeleteView,
}) => {
  const handleDelete = (e: React.MouseEvent, viewTitle: string) => {
    e.stopPropagation()
    if (onDeleteView) {
      onDeleteView(viewTitle)
    }
  }

  return (
    <Modal
      title="Sélectionner une vue"
      confirmButtonText="Fermer"
      onCancel={onClose}
      onConfirm={onClose}
      size="sm"
    >
      <div className="space-y-2">
        {views.map(view => (
          <button
            key={view.title}
            className={`flex w-full h-10 items-center justify-between gap-2 px-4 py-2 rounded-lg transition-colors ${
              view.selected
                ? 'bg-[var(--color-primary)] text-white'
                : 'bg-[var(--color-gray-100)] hover:bg-[var(--color-gray-200)] text-[var(--color-text-primary)]'
            }`}
            onClick={() => {
              onSelectView(view.title)
              onClose()
            }}
          >
            <div className="flex-1 text-left">{view.title}</div>
            {onDeleteView && view.title !== 'par défaut' && views.length > 1 && (
              <button
                onClick={e => handleDelete(e, view.title)}
                className="p-1 rounded transition-colors bg-[var(--color-error)]/20 hover:bg-[var(--color-error)]/30"
                title="Supprimer la vue"
              >
                <Trash className="w-4 h-4" weight="regular" color="var(--color-error)" />
              </button>
            )}
          </button>
        ))}
      </div>
    </Modal>
  )
}
